import { Box, Image, Text } from '@chakra-ui/react';

const GoYSimpleCard = ({ simpleCardData }) => {
  return (
    <>
      {simpleCardData.simpleCards.map(data => {
        return (
          <Box
            // width="340px"
            mr={{ lg: '1.2rem', md: '1.5rem', sm: '0' }}
            ml={{ lg: '0', md: '10px', sm: '1rem' }}
            mb={{ lg: '4rem', md: '60px', sm: '60px' }}
            width={{
              lg: 'calc((100% - 69px) / 3)',
              md: 'calc((100% - 69px) / 2)',
              sm: '100%',
            }}
          >
            <Box
              width={{ base: '40%', lg: 'auto', md: 'auto' }}
              display={{ lg: 'block', md: 'block', base: 'inline-block' }}
              pl={{ base: '16px', lg: '0', md: '0' }}
              verticalAlign={{ base: 'top', lg: 'none', md: 'none' }}
              paddingBottom="20px"
            >
              <Image src={data.rectangularImage.url} width="100%" />
              <Box
                width="80%"
                height="20px"
                margin="0 auto"
                backgroundColor={data.highlightColour?.hex}
                display={{ base: 'none', lg: 'block', md: 'block' }}
              ></Box>
            </Box>
            <Text
              fontFamily="FedraSansStd-book, sans-serif"
              fontSize={{ base: '14px', md: '18px' }}
              fontWeight="400"
              lineHeight={{ base: '22px', md: '28px' }}
              // textAlign="left"
              p={{ lg: '0 12px', md: '0', base: '0px 0 20px 20px' }}
              width={{ lg: '100%', md: '100%', base: '60%' }}
              display={{ lg: 'block', md: 'block', base: 'inline-block' }}
              textAlign={{ lg: 'left', md: 'center', base: 'left' }}
            >
              {data.descriptionText}
            </Text>
          </Box>
        );
      })}
    </>
  );
};

export default GoYSimpleCard;
